import { FormStore } from '@roc/feature-app-core';
import {
  createCurrencyField,
} from '../../../components/temp/componentBuiderTemp';
import { observer } from 'mobx-react';


export const MonthlyMarketRent = observer(({ store }: { store: FormStore }) => {
  return (
    <>
      {createCurrencyField({
        label: "Monthly Market Rent",
        fieldName: 'totalGrossMonthlyRent',
        testId: 'totalGrossMonthlyRent',
        store,
        standaloneLabel: false,
        addMarkForRequiredFields: true,
        isRequired: true
      })}
    </>
  );
});